import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faPencilAlt,
  faTrash,
  faUndo,
  faExchangeAlt,
  faWrench,
  faCheckCircle,
  faBan,
  faRedoAlt
} from '@fortawesome/free-solid-svg-icons';

interface AssetActionDropdownItemsProps {
  onView?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
  onReturn?: () => void;
  onAssign?: () => void;
  onPutMaintenance?: () => void;
  onCompleteMaintenance?: () => void;
  onRetire?: () => void;
  onReactivate?: () => void;
  assetStatus?: string; // The current status of the asset
  isAssigned?: boolean; // Whether the asset is currently assigned
}

const AssetActionDropdownItems = ({
  onView,
  onEdit,
  onRemove,
  onReturn,
  onAssign,
  onPutMaintenance,
  onCompleteMaintenance,
  onRetire,
  onReactivate,
  assetStatus = 'available',
  isAssigned = false
}: AssetActionDropdownItemsProps) => {
  const isInMaintenance = assetStatus === 'maintenance';
  const isRetired = assetStatus === 'retired';

  return (
    <>
      <Dropdown.Item onClick={onView}>
        <FontAwesomeIcon icon={faEye} className="me-2 text-info" />
        View
      </Dropdown.Item>
      <Dropdown.Item onClick={onEdit}>
        <FontAwesomeIcon icon={faPencilAlt} className="me-2 text-warning" />
        Edit
      </Dropdown.Item>

      <Dropdown.Divider />

      {/* Show Return only if asset is assigned */}
      {isAssigned ? (
        <Dropdown.Item onClick={onReturn}>
          <FontAwesomeIcon icon={faUndo} className="me-2 text-success" />
          Return Device
        </Dropdown.Item>
      ) : (
        /* Show Assign if asset is available/unassigned */
        <Dropdown.Item onClick={onAssign}>
          <FontAwesomeIcon icon={faExchangeAlt} className="me-2 text-primary" />
          Assign Device
        </Dropdown.Item>
      )}

      <Dropdown.Divider />

      {/* Maintenance buttons - show based on current status */}
      {isInMaintenance ? (
        <Dropdown.Item onClick={onCompleteMaintenance}>
          <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
          Complete Maintenance
        </Dropdown.Item>
      ) : (
        /* Only show put in maintenance if asset is assigned */
        isAssigned && (
          <Dropdown.Item onClick={onPutMaintenance}>
            <FontAwesomeIcon icon={faWrench} className="me-2 text-warning" />
            Put in Maintenance
          </Dropdown.Item>
        )
      )}

      <Dropdown.Divider />

      {/* Retire/Reactivate buttons - show based on current status */}
      {isRetired ? (
        <Dropdown.Item onClick={onReactivate}>
          <FontAwesomeIcon icon={faRedoAlt} className="me-2 text-success" />
          Reactivate Device
        </Dropdown.Item>
      ) : (
        /* Only show retire option if asset is available and not in maintenance */
        !isAssigned &&
        !isInMaintenance && (
          <Dropdown.Item onClick={onRetire}>
            <FontAwesomeIcon icon={faBan} className="me-2 text-danger" />
            Retire Device
          </Dropdown.Item>
        )
      )}

      <Dropdown.Divider />
      <Dropdown.Item onClick={onRemove} className="text-danger">
        <FontAwesomeIcon icon={faTrash} className="me-2" />
        Remove
      </Dropdown.Item>
    </>
  );
};

export default AssetActionDropdownItems;
